import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import UserServices from '../services/UserServices';


function Login() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [emailError, setEmailError] = useState("");
    const [message, setMessage] = useState("");
    const [passwordError, setPasswordError] = useState("");
    const navigate = useNavigate();
    const url = process.env.REACT_APP_SITE_URL;

    // Vérifier si l'utilisateur est déjà connecté
    useEffect(() => {
        if (sessionStorage.getItem('id_user') && sessionStorage.getItem('token')) {
            navigate('/rapport/frontend');
        }
    }, []);

    const handleSubmit = (e) => {
        e.preventDefault();
        setEmailError("");
        setPasswordError("");
        if (email === "") {
            setEmailError("Veuillez entrer une adresse email.");
        } else if (!/\S+@\S+\.\S+/.test(email)) {
            setEmailError("Veuillez entrer une adresse email valide.");
        }
        if (password === "") {
            setPasswordError("Veuillez entrer un mot de passe.");
        } else if (password.length < 8) {
            setPasswordError("Le mot de passe doit contenir au moins 8 caractères.");
        }
        if (email && password && !emailError && !passwordError) {
            UserServices.Login(email, password).then(data => {
                console.log(data);
                if (data['success'] === true) {
                    let user = data['user'];
                    sessionStorage.setItem('token', data['token']);
                    sessionStorage.setItem('id_user', user.id);
                    sessionStorage.setItem('first_name', user.username);
                    sessionStorage.setItem('last_name', user.last_name);
                    sessionStorage.setItem('access', user.access);
                    console.log(sessionStorage.getItem('token'));
                    console.log(sessionStorage.getItem('id_user'));
                    console.log(sessionStorage.getItem('first_name'));
                    console.log(sessionStorage.getItem('last_name'));
                    console.log(sessionStorage.getItem('access'));
                    window.location.href = '/rapport/frontend/';
                } else if (data['success'] === false) {
                    setMessage(data['message']);
                    setEmail("");
                    setPassword("");
                }

            });
        }
    };

    return (
        <div className="container d-flex align-items-center justify-content-center vh-100">
            <div className="card p-3">
                <h2 className="mb-3">Se connecter</h2>
                <p>User : webdev@afribonemali.net / Test@123</p>
                <p>Admin : youssoufdoumbia@afribonemali.net / Test@123</p>
                {message && <div className="alert alert-danger mt-1">{message}</div>}
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label htmlFor="email">Adresse email</label>
                        <input type="email" className="form-control mb-3" id="email" value={email} onChange={(e) => setEmail(e.target.value)} />
                        {emailError && <div className="text-danger">{emailError}</div>}
                    </div>
                    <div className="form-group">
                        <label htmlFor="password">Mot de passe</label>
                        <input type="password" className="form-control mb-3" id="password" value={password} onChange={(e) => setPassword(e.target.value)} />
                        {passwordError && <div className="text-danger">{passwordError}</div>}
                    </div>
                    <button type="submit" className="btn btn-primary mb-3">Se connecter</button>
                </form>
                <Link to="/rapport/frontend/forget-password" className="">Mot de passe oublié</Link>
            </div>
        </div>
    );
}

export default Login;